"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _facebook = _interopRequireDefault(require("./facebook.theme"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var facebook = {
  app: {
    atomicPublisherUnit: "page",
    atomicFollowerUnit: "fan",
    url_count_limit: 35750
  },
  brand: {
    codename: "facebook",
    name: "Facebook",
    color: _facebook["default"].tenant.primary,
    logoProps: {
      name: "facebookLogo"
    }
  },
  exclusionGroupCatalog: {
    headerColor: "black",
    headerIcon: "modelBuilder"
  },
  engagementManager: {
    headerColor: "turquoise",
    headerIcon: "engagementManager",
    providerLink: {
      providerExternalIdLabel: "Ad Account",
      linkType: "ad_account"
    }
  },
  profile: {
    headerColor: "berry",
    showProfileCover: true,
    profileMetrics: [{
      title: "Fans",
      dataKey: "fan_count"
    }, {
      title: "Videos",
      dataKey: "video_count"
    }, {
      title: "Median Video Views",
      subtitle: "Last 28 Days",
      dataKey: "median_views_per_video"
    }],
    videoMetrics: [{
      title: "Avg Engagements",
      dataKey: "engagement_count_avg"
    }, {
      title: "Videos > 3 min",
      dataKey: "duration_seconds_count_gte_180",
      divisorKey: "count",
      type: "percentage"
    }, {
      title: "Avg Likes",
      dataKey: "like_count_avg"
    }, {
      title: "Avg Length",
      dataKey: "duration_seconds_avg",
      type: "duration"
    }],
    videosGrid: {
      tabs: [{
        title: "Most Recent",
        icon: "today",
        dataKey: "mostRecent",
        order: "pub_date",
        query: {
          ordering: "-pub_date"
        }
      }, {
        title: "Most Engaging",
        icon: "thumb_up",
        dataKey: "mostEngaged",
        order: "engagement_count",
        query: {
          ordering: "-reaction_count"
        }
      }, {
        title: "High Risk",
        icon: "warning",
        dataKey: "highRisk",
        order: "risk_sort_only",
        query: {
          ordering: "-pub_date",
          brandsafety_video_label: "High Risk"
        }
      }],
      thumbnailMetrics: [{
        label: "Reactions",
        dataKey: "reaction_count",
        type: "number"
      }, {
        label: "Published",
        dataKey: "pub_date",
        type: "date"
      }]
    },
    tags: {
      title: "Video Content Tags"
    }
  },
  mainCatalog: {
    headerColor: "purple",
    headerIcon: "ribbon",
    experimentalSearchEnabled: true,
    experimentalSearchOptions: [{
      label: "Min Term Frequency",
      value: "mintermfreq"
    }, {
      label: "Low Frequency",
      value: "low_frequency"
    }],
    featuredMetrics: [{
      label: "Monthly Views",
      dataKey: "median_views_per_video_sum",
      icon: "views"
    }, {
      label: "Pages",
      dataKey: "count",
      icon: "page"
    }, {
      label: "Videos",
      dataKey: "video_count_sum",
      icon: "videosTriangle"
    }],
    facets: [{
      label: "Quality",
      filters: ["SlateScoreFilter"]
    }, {
      label: "Suitability Ratings",
      filters: ["SuitabilityFilter"],
      tooltip: "SuitabilityDescriptionList"
    }, {
      label: "Primary Category",
      filters: ["ContentCategoryFilter"]
    }, {
      label: "Audience",
      filters: ["FanCountFilter", {
        label: "Median Views (Last 30 Days)",
        type: "MonthlyViewsFilter",
        queryParam: "median_views_per_video__range",
        aggregatesKey: "median_views_per_video"
      }, "LanguageFilter"]
    }],
    table: {
      showDownloadAll: true,
      downloadAllRequiredPermissions: ["export_profiles_catalog"],
      defaultSortOrder: "-median_views_per_video",
      columns: [{
        dataKey: "picture",
        cellType: "picture"
      }, {
        label: "Name",
        dataKey: "title",
        cellType: "title"
      }, {
        label: "Primary Category",
        dataKey: "category"
      }, {
        label: "DV Media Score",
        dataKey: "unified_slatescore",
        cellType: "slateScore"
      }, {
        label: "Suitability",
        dataKey: "suitability",
        cellType: "suitability",
        sorting: false
      }, {
        label: "Fans",
        dataKey: "fan_count",
        cellType: "number"
      }, {
        label: "Videos",
        dataKey: "video_count",
        cellType: "number"
      }, {
        label: "Monthly Views",
        "default": true,
        dataKey: "median_views_per_video",
        cellType: "number",
        tooltip: "The median view count for videos published within the last 28 days"
      }]
    }
  },
  videoCatalog: {
    header: {
      showHighRisk: {
        requiredPermissions: []
      }
    },
    table: {
      columns: [{
        dataKey: "thumbnail",
        cellType: "videoThumbnail"
      }, {
        label: "Title",
        dataKey: "title",
        cellType: "videoTitle"
      }, {
        label: "Reactions",
        dataKey: "reaction_count",
        cellType: "number"
      }, {
        label: "Publish Date",
        dataKey: "pub_date",
        cellType: "date"
      }, {
        label: "Risk Flag",
        dataKey: "brandsafety_video_label",
        cellType: "highRiskFlag"
      }]
    }
  },
  videoPlayer: {
    videoStats: [{
      label: "Reactions",
      dataKey: "reaction_count"
    }, {
      label: "Engagements",
      dataKey: "engagement_count"
    }, {
      label: "Comments",
      dataKey: "comment_count"
    }],
    externalLink: {
      label: "View on Facebook",
      iconProps: {
        name: "facebookLogo"
      }
    }
  },
  charts: {
    engagements: {
      title: "Engagement",
      subheading: "Average engagements (likes + dislikes + comments) per video",
      xAxisLabel: "Number of likes, dislikes and comments",
      verbosedLabels: {
        _page: "This Page",
        _category: "Pages with Same Primary Category",
        _all: "Platform Avg."
      }
    },
    publishingCadence: {
      title: "Publishing Cadence",
      subheading: "Videos published over the last 12 weeks (by week)",
      legendOverallAvg: "Platform Avg.",
      legendThisPage: "This Page",
      legendPrimaryCateory: "Pages with Same Primary Category",
      yAxisLabel: "Number of videos",
      xAxisLabel: "Weeks"
    },
    length: {
      title: "Video Length",
      subheading: "Average video length in seconds",
      xAxisLabel: "Video length (sec.)",
      verbosedLabels: {
        _page: "This Page",
        _category: "Pages with Same Primary Category",
        _all: "Platform Avg."
      }
    }
  },
  reports: {
    reportType: "fb_campaign_page_csv"
  },
  reporting: {
    headerColor: "berry",
    headerIcon: "chart",
    reportTypes: [{
      reportType: "page_delivery_report",
      downloadLinks: [{
        label: "Report Files",
        downloadReportType: "output_zip"
      }, {
        label: "Low Touch PPT",
        downloadReportType: "fb_lowtouch_ppt"
      }]
    }, {
      reportType: "content_delivery_report",
      downloadLinks: [{
        label: "Report Files",
        downloadReportType: "output_zip"
      }, {
        label: "Low Touch PPT",
        downloadReportType: "fb_lowtouch_ppt"
      }]
    }, {
      reportType: "generic_page_csv",
      downloadLinks: [{
        label: "CSV",
        downloadReportType: "csv_output"
      }]
    }, {
      reportType: "fb_campaign_page_csv",
      downloadLinks: [{
        label: "CSV",
        downloadReportType: "csv_output"
      }]
    }, {
      reportType: "fb_api_entity_page",
      downloadLinks: [{
        label: "Report Files",
        downloadReportType: "output_zip"
      }, {
        label: "Low Touch PPT",
        downloadReportType: "fb_lowtouch_ppt"
      }]
    }, {
      reportType: "fb_api_entity_video",
      downloadLinks: [{
        label: "Report Files",
        downloadReportType: "output_zip"
      }, {
        label: "Low Touch PPT",
        downloadReportType: "fb_lowtouch_ppt"
      }]
    }, {
      reportType: "fb_csv_entity_video",
      downloadLinks: [{
        label: "CSV",
        downloadReportType: "csv_output"
      }]
    }, {
      reportType: "fb_csv_entity_page",
      downloadLinks: [{
        label: "CSV",
        downloadReportType: "csv_output"
      }]
    }, {
      reportType: "fb_csv_no_entity_video",
      downloadLinks: [{
        label: "CSV",
        downloadReportType: "csv_output"
      }]
    }, {
      reportType: "fb_csv_no_entity_page",
      downloadLinks: [{
        label: "CSV",
        downloadReportType: "csv_output"
      }]
    }, {
      reportType: "fb_csv_no_entity_page_join",
      downloadLinks: [{
        label: "CSV",
        downloadReportType: "csv_output"
      }]
    }]
  },
  navigationMenu: [{
    label: "OS Ratings",
    iconProps: {
      name: "contentRatings"
    },
    routeRef: "mainCatalog",
    routeRefMatches: ["mainCatalog", "profile", "profileVideos"]
  }, {
    label: "Engagements Manager",
    iconProps: {
      name: "engagementManager"
    },
    routeRef: "engagementManager",
    routeRefMatches: ["engagementManager"]
  }, {
    label: "List Management",
    iconProps: {
      name: "blocklist"
    },
    codename: "block_lists",
    subMenu: [{
      label: "Exclusion Groups",
      iconProps: {
        name: "exclusionGroup"
      },
      routeRef: "exclusionGroupCatalog",
      routeRefMatches: ["exclusionGroupCatalog"]
    }, {
      label: "Account Graph (deprecated)",
      iconProps: {
        name: "account_graph"
      },
      routeRef: "blocklistCatalog",
      routeRefMatches: ["blocklistCatalog"]
    }]
  }, {
    label: "OS Intelligence",
    iconProps: {
      name: "reports"
    },
    routeRef: "reportCatalog",
    routeRefMatches: ["reportCatalog"]
  }],
  modelBuilder: {
    listMetrics: [{
      label: "Pages",
      dataKey: "count"
    }, {
      label: "Videos",
      dataKey: "video_count_sum"
    }, {
      label: "Monetized Videos",
      dataKey: "monetized_video_count_sum"
    }]
  },
  routes: {
    home: {
      url: "/",
      title: "Home"
    },
    mainCatalog: {
      component: "MainCatalog",
      requiredPermissions: ["view_profiles_catalog"],
      title: "DV Content Settings",
      url: "/pages",
      "default": true
    },
    profile: {
      component: "Profile",
      requiredPermissions: ["view_profile"],
      title: "DV Content Settings",
      url: "/pages/:id"
    },
    profileVideos: {
      component: "Profile",
      requiredPermissions: ["view_videos_catalog"],
      title: "DV Content Settings",
      url: "/pages/:id/videos"
    },
    reporting: {
      component: "ReportCatalog",
      requiredPermissions: ["view_reports_catalog"],
      title: "DV Intelligence",
      url: "/reports"
    },
    engagementManager: {
      component: "EngagementManager",
      requiredPermissions: ["view_engagement"],
      title: "DV Engagements",
      url: "/engagements-manager"
    },
    engagementListEdit: {
      component: "EngagementListEdit",
      requiredPermissions: ["change_engagement_list"],
      title: "Model Builder",
      url: "/engagements-manager/model/:id"
    },
    blocklistCatalog: {
      component: "BlocklistCatalog",
      requiredPermissions: ["view_linked_accounts_graph", "view_test_feature"],
      title: "Account Graph",
      url: "/blocklists"
    },
    exclusionGroupCatalog: {
      component: "ExclusionGroupsCatalog",
      requiredPermissions: ["view_target_sets_catalog"],
      title: "Exclusion Groups",
      url: "/exclusion-groups"
    },
    disqualifiedProfiles: {
      component: "DisqualifiedProfiles",
      requiredPermissions: ["view_decommissioned_profiles_catalog"],
      title: "Disqualified Pages",
      url: "/disqualified-pages"
    },
    disqualifiedProfile: {
      component: "Profile",
      requiredPermissions: ["view_decommissioned_profile"],
      title: "Disqualified Page",
      url: "/disqualified-pages/:id"
    },
    disqualifiedProfileVideos: {
      component: "Profile",
      requiredPermissions: ["view_decommissioned_videos_catalog"],
      title: "Disqualified Page Videos",
      url: "/disqualified-pages/:id/videos"
    },
    terms: {
      component: "Terms",
      title: "DV Terms and Conditions",
      url: "/terms"
    }
  }
};
var _default = exports["default"] = facebook;